import { Command } from "@ckeditor/ckeditor5-core";
import { v4 as uuidv4 } from "uuid";

export default class CreateMarksCommand extends Command {
  execute(type) {
    const editor = this.editor;
    const model = editor.model;
    const selection = model.document.selection;

    if (selection.isCollapsed) {
      model.change((writer) => {
        const cursorLocation = uuidv4();
        const IPRElement = writer.createElement("itemPointReference", {
          "data-uuid": cursorLocation,
        });
        const itemID = editor.config.get("itemID");
        writer.insert(IPRElement, selection.anchor);

        editor.fire("cde:createHighlight", {
          data: editor.data.get(),
          items: [itemID],
          point: cursorLocation,
          __typename: "ItemPointReference",
        });
      });
    } else {
      model.change((writer) => {
        const begin = uuidv4();
        const end = uuidv4();
        const itemID = editor.config.get("itemID");

        writer.insertElement(
          "inlineMarkElement",
          { "data-uuid": begin },
          selection.isBackward ? selection.focus : selection.anchor,
        );
        writer.insertElement(
          "inlineMarkElement",
          { "data-uuid": end },
          selection.isBackward ? selection.anchor : selection.focus,
        );

        editor.fire("cde:createHighlight", {
          begin,
          data: editor.data.get(),
          end,
          items: [itemID],
          __typename: "Highlight",
        });
      });
    }
  }

  refresh() {
    const editor = this.editor;
    const model = editor.model;
    const selection = model.document.selection;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "inlineMarkElement",
    );
    this.value = selection.isCollapsed;
    const itemID = editor.config.get("itemID");

    this.isEnabled = itemID && selection && allowedIn !== null;
  }
}
